import Vue from 'vue'
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo, {
    container: "#contract",
    duration: 500,
    easing: "ease",
    offset: -25,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
  })



// WEBPACK FOOTER //
// ./src/shared/plugins/VueScrollTo.js